var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("core-app-bar"),
      _vm._v(" "),
      _c("core-drawer"),
      _vm._v(" "),
      _c("core-view"),
      _vm._v(" "),
      _c("core-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }